/** `updateProductQuantity` replaces a cart entry's quantity rather than incrementing it, so the amount
 * actually added by an update is the difference from what was already there, not the new target itself. */
export const getAddedCartQuantity = (targetQuantity: number, existingQuantity?: number): number =>
  targetQuantity - (existingQuantity ?? 0)
